export const ManageRolesContent = {
  pageTitle: 'Roles',
  pageDescription:
    'Cohorts that gate event visibility and organize members. Admin is fixed and cannot be edited or removed.',
  actions: {
    create: 'Create role',
    edit: 'Edit role',
    delete: 'Delete role',
    cancel: 'Cancel',
    close: 'Close',
  },
  search: {
    placeholder: 'Search name or key',
  },
  counts: {
    showing: (filtered: number, total: number) =>
      `Showing ${filtered} of ${total} ${filtered === 1 ? 'role' : 'roles'}`,
  },
  badges: {
    system: 'System',
  },
  emptyStates: {
    noRoles: 'No roles have been created yet.',
    noRolesDescription:
      'Create a role to group members and target events for a new program.',
    noFilteredRoles: 'No roles match your search.',
  },
  detail: {
    overviewLabel: 'Role overview',
    keyLabel: 'Role key',
    colorLabel: 'Color',
    descriptionLabel: 'Description',
    statusLabel: 'Status',
    systemStatus: 'System role',
    customStatus: 'Custom role',
    systemDescription:
      'Protected by the platform. Its key and role settings cannot be changed.',
    customDescription:
      'Custom role metadata can be updated while its key remains fixed.',
    noDescription: 'No description has been added for this role.',
    notFound: 'Role not found.',
  },
  form: {
    createTitle: 'Create role',
    editTitle: 'Edit role',
    systemTitle: 'System role',
    createDescription:
      'Set up a role with a stable key generated from its name.',
    editDescription:
      'Update the role label, color, or description. The key stays locked.',
    systemDescription:
      'This protected system role is fixed and cannot be edited or deleted.',
    fields: {
      displayName: 'Display name',
      displayNamePlaceholder: 'Mentors - 2026',
      description: 'Description',
      descriptionPlaceholder: 'Optional notes for future admins',
      color: 'Color',
      keyPreview: 'Role key preview',
      key: 'Role key',
      emptyKey: 'Enter a name to preview the key',
    },
    keyHelp:
      'Used for event targeting and imports. Generated from the display name and cannot be changed after creation.',
    lockedKeyHelp:
      'Renaming the role never changes this key. Event targeting keeps working.',
    createConfirm: 'Create role',
    editConfirm: 'Save changes',
    creating: 'Creating...',
    saving: 'Saving...',
    validation: {
      missingName: 'Enter a role name.',
      emptyKey: 'The role name must include at least one letter or number.',
    },
  },
  deleteDrawer: {
    title: (name: string) => `Delete ${name}?`,
    description: 'What happens when you delete this role:',
    bullets: [
      'It is removed from event targeting and role filters.',
      'It can only be deleted while no members, groups, or events use it.',
      'If anything still references it, deletion is blocked until reassigned.',
      'This cannot be undone.',
    ],
    confirm: 'Delete role',
    deleting: 'Deleting...',
  },
  toast: {
    createSuccessTitle: 'Role created',
    createSuccessDescription: (name: string) => `${name} is now available.`,
    updateSuccessTitle: 'Role updated',
    updateSuccessDescription: (name: string) => `${name} has been updated.`,
    deleteSuccessTitle: 'Role deleted',
    deleteSuccessDescription: (name: string) => `${name} has been removed.`,
    errorTitle: 'Role update failed',
    deleteErrorTitle: 'Could not delete role',
  },
};
